'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$3() {
}
export { $c_Ljava_time_temporal_TemporalQueries$$anon$3 as $c_Ljava_time_temporal_TemporalQueries$$anon$3 };
$p = $c_Ljava_time_temporal_TemporalQueries$$anon$3.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$3;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$3() {
}
export { $h_Ljava_time_temporal_TemporalQueries$$anon$3 as $h_Ljava_time_temporal_TemporalQueries$$anon$3 };
$h_Ljava_time_temporal_TemporalQueries$$anon$3.prototype = $p;
$p.dQ = (function(temporal) {
  return temporal.cg(this);
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$3 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_TemporalQueries$$anon$3, "java.time.temporal.TemporalQueries$$anon$3", ({
  mD: 1,
  aT: 1
}));
export { $d_Ljava_time_temporal_TemporalQueries$$anon$3 as $d_Ljava_time_temporal_TemporalQueries$$anon$3 };
